import { SwiperClass } from 'swiper/react';

export type SwiperWithPaginationEvents = SwiperClass & {
  on: (event: 'paginationUpdate' | 'paginationRender', cb: () => void) => void;
};

export const getBreakpoint = (width: number) => {
  if (width < 720) return 'mobile';
  if (width < 1080) return 'tablet';
  return 'desktop';
};

export const shouldReinitSwiper = (
  currentBreakpoint: string,
  lastBreakpoint: string,
  currentWidth: number,
  lastWidth: number
) => {
  return (
    currentBreakpoint !== lastBreakpoint ||
    (currentBreakpoint === 'desktop' &&
      Math.abs(currentWidth - lastWidth) > 200)
  );
};

export const setupPaginationClickHandler = (
  paginationRef: React.RefObject<HTMLDivElement>,
  videoSwiper: SwiperClass | null,
  goToIndex: (index: number) => void
) => {
  const el = paginationRef.current;
  if (!el || !videoSwiper) return;

  const onClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const bullet = target.closest(
      '.swiper-pagination-bullet'
    ) as HTMLElement | null;
    if (!bullet) return;

    const bullets = Array.from(
      el.querySelectorAll('.swiper-pagination-bullet')
    );
    const idx = bullets.indexOf(bullet);
    if (idx >= 0) {
      goToIndex(idx);
    }
  };

  el.addEventListener('click', onClick);
  return () => el.removeEventListener('click', onClick);
};
